import { createWebHistory, createRouter } from 'vue-router'

export const constantRoutes = [
  {
    path: '/',
    redirect: '/ai-chat',
    hidden: true,
  },
  {
    path: '/ai-chat',
    component: () => import('@/views/aiChat/index.vue'),
    hidden: true,
    meta: {
      title: '神笔马良AI',
    },
  },
  {
    path: '/ai-chat/image-cut-diagram',
    component: () => import('@/views/imageCutDiagram/index.vue'),
    hidden: true,
    meta: {
      title: 'AI抠图',
    },
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/ai-chat',
    hidden: true,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: constantRoutes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    return { top: 0 }
  },
})

export default router
